import React, { useCallback, useMemo } from 'react';
import TableJobs from '../../components/TableJobs';
import { parseJobsToExpanded, filterDataByDateAndSearch } from '../../../../../../utils/helpers';
import RowSubComponentCompletedAsync from '../../components/RowSubComponentCompletedAsync';
import { useParams } from 'react-router-dom';


const JobsCompleted = ({ jobs, searchText, refetchJobsCompleted, onClickDuplicate, startDate, endDate }) => {
    
    const { id } = useParams();

    // If exists id then set active job as first item
    const jobsExpanded = useMemo(
        () => parseJobsToExpanded(jobs, id),
        [jobs, id]
    );

    const jobsFiltered = useMemo(
        () => {
            // return filterDataByString(jobsExpanded, searchText, job => job?.title);
            return filterDataByDateAndSearch(jobsExpanded, searchText, startDate, endDate);
        },
        [jobsExpanded, searchText, startDate, endDate]
    );
  

    

    const renderRowSubComponent = useCallback(
        ({ row, rowProps, visibleColumns }) => (
            <RowSubComponentCompletedAsync
                row={row}
                rowProps={rowProps}
                visibleColumns={visibleColumns}
                refetchJobsCompleted={refetchJobsCompleted}
                onClickDuplicate={onClickDuplicate}
            />
        ),
        [refetchJobsCompleted, onClickDuplicate]
    );

    return (
        <TableJobs
            jobs={jobsFiltered}
            renderRowSubComponent={renderRowSubComponent}
        />
    )
}

export default JobsCompleted;
